const topics = [
  { tag: '顶流塌房', heat: '9.8万热度', icon: 'ri-fire-line', color: 'text-primary-500 bg-primary-50' },
  { tag: '恋情实锤', heat: '8.5万热度', icon: 'ri-heart-line', color: 'text-secondary-500 bg-secondary-50' },
  { tag: '综艺翻车', heat: '7.2万热度', icon: 'ri-emotion-line', color: 'text-accent-600 bg-accent-50' },
  { tag: '直播爆雷', heat: '6.8万热度', icon: 'ri-live-line', color: 'text-primary-500 bg-primary-50' },
  { tag: '合同纠纷', heat: '5.9万热度', icon: 'ri-file-text-line', color: 'text-secondary-500 bg-secondary-50' },
  { tag: '选秀内幕', heat: '5.4万热度', icon: 'ri-star-line', color: 'text-accent-600 bg-accent-50' },
  { tag: '代言翻车', heat: '4.7万热度', icon: 'ri-advertisement-line', color: 'text-primary-500 bg-primary-50' },
  { tag: '私生饭事件', heat: '4.2万热度', icon: 'ri-user-search-line', color: 'text-secondary-500 bg-secondary-50' },
  { tag: '税务风波', heat: '3.8万热度', icon: 'ri-money-cny-circle-line', color: 'text-accent-600 bg-accent-50' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">热门话题</h2>
        <p className="text-sm text-foreground-500 mb-8">当前最受关注的吃瓜话题标签，看看大家都在讨论什么</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((topic) => (
            <div
              key={topic.tag}
              className="flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-colors cursor-pointer group"
            >
              <span className={`w-10 h-10 flex items-center justify-center rounded-lg ${topic.color} flex-shrink-0`}>
                <i className={`${topic.icon} text-lg`}></i>
              </span>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">{topic.tag}</p>
                <p className="text-xs text-foreground-500 mt-0.5">{topic.heat}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}